@if(offers()) {
@switch (mediaService.media()) {
@case ('xs') {
<ng-container *ngTemplateOutlet="mobileoffer"></ng-container>
}
@case ('sm') {
<ng-container *ngTemplateOutlet="mobileoffer"></ng-container>
}
@case ('md') {
<ng-container *ngTemplateOutlet="mobileoffer"></ng-container>
}
@default {
<ng-container *ngTemplateOutlet="desktopoffer"></ng-container>
}
}
}

<ng-template #mobileoffer>
    <div class="offerwrappermobile">
        <div class="offerbodymobile" [style.background-color]=" showitem() ? '#fee0cf' : ''"
            (click)="openItem($event)">
            <div class="bosysavatar">
                <mat-icon>local_offer</mat-icon>
            </div>
            @if(showitem()) {
            <span (click)="gotolist($event)">
                Meine Angebote
            </span>
            }
        </div>
        @if(showitem()) {
        <div class="namewrapper">
            @for (item of offers(); let k= $index; track k) {
            <button class="bosysbutton1" [class.bosysbutton1active]="item.recid === currentrecid()"
                (click)="gotoOffer(item)">{{k + 1}}. {{item.name}}</button>
            }
        </div>
        }
    </div>
</ng-template>
<ng-template #desktopoffer>
    <div class="offerwrapper">
        <div class="offerbody" (click)="gotolist($event)">
            <div class="bosysavatar">
                <mat-icon>local_offer</mat-icon>
            </div>
            <span>
                Meine Angebote
            </span>
        </div>
        <div class="namewrapper">
            @for (item of offers(); let k= $index; track k) {
            <button class="bosysbutton1" [class.bosysbutton1active]="item.recid === currentrecid()"
                (click)="gotoOffer(item)">{{k + 1}}. {{item.name}}</button>
            }
        </div>
    </div>
</ng-template>